// Rerender certain SVGs with canvas because Chrome renders them poorly.
const UPSAMPLE_FACTOR = 3
const upsample = img => {
  if (img.getAttribute('crossorigin') !== 'anonymous') {
    console.warn('SVG render may fail due to missing crossorigin="anonymous"');
  }

  // First render at the upsampled size.
  const canvas = document.createElement('canvas')
  const upsampledContext = canvas.getContext('2d')
  const upsampledImage = new Image()
  const targetWidth = img.clientWidth
  const targetHeight = img.clientHeight
  upsampledImage.src = img.src
  upsampledImage.onload = () => {
    upsampledContext.clearRect(0, 0, canvas.width, canvas.height)
    canvas.width = targetWidth * UPSAMPLE_FACTOR
    canvas.height = targetHeight * UPSAMPLE_FACTOR
    upsampledContext.drawImage(upsampledImage, 0, 0)
    // Then downsample to the target size.
    const upsampled = new Image()
    upsampled.onload = () => {
      const downsampledCanvas = document.createElement('canvas')
      const downsampledContext = downsampledCanvas.getContext('2d')
      downsampledContext.imageSmoothingEnabled = true
      downsampledCanvas.width = targetWidth
      downsampledCanvas.height = targetHeight
      downsampledContext.drawImage(upsampled,
        0, 0, canvas.width, canvas.height,
        0, 0, targetWidth, targetHeight)
      downsampledCanvas.classList = img.classList
      img.parentNode.replaceChild(downsampledCanvas, img)
    }
    upsampled.src = canvas.toDataURL()
  }
};

document.addEventListener('turbo:load', () => {
  const els = document.querySelectorAll('img[src$=".svg"][data-svg-render]')
  els.forEach(img => upsample(img))
});
